import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DefaultLayout } from "../../layouts/Default";
import { Formik } from "formik";
import { TopNavigation } from "../../themes/Default/components/TopNavigation";
import { Title } from "../../themes/Default/components/Title";
import { Breadcrumps } from "../../themes/Default/components/Breadcrumps";
import { Link } from "../../themes/Default/components/Breadcrumps/components/Link";
import { Main } from "../../themes/Default/components/Main";
import { Tabs } from "../../themes/Default/components/Tabs";
import { ButtonBack, Button } from "../../themes/Default/components/TopNavigation/components/Button";
import { Form } from "../../themes/Default/components/Form";
import { Row } from "../../themes/Default/components/Form/components/Row";
import { Wizard } from "../../themes/Default/components/Wizard";
import { Step } from "../../themes/Default/components/Wizard/Step";
import { Field } from "../../themes/Default/components/Form/components/Row/components/Field";
import { Select } from "../../themes/Default/components/Form/components/Select";
import { List } from "../../themes/Default/components/List";
import { prepareSelect } from "../../services/core/Select";
import { Header as ListHeader } from "../../themes/Default/components/List/components/Header";
import { Title as ListTitle } from "../../themes/Default/components/List/components/Header/components/Title";
import { Body as ListBody } from "../../themes/Default/components/List/components/Body";
import { TableHead } from "../../themes/Default/components/List/components/Body/components/TableHead";
import { TableBody } from "../../themes/Default/components/List/components/Body/components/TableBody";
import { TableRow } from "../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow";
import { TableHeadCell } from "../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow/components/TableHeadCell";
import { TableDataCell } from "../../themes/Default/components/List/components/Body/components/TableBody/components/TableDataCell";
import { studentsManagement } from "../../hooks/api/StudentsManagement";
import { groupsManagement } from "../../hooks/api/GroupsManagement";
import { useTranslation } from "react-i18next";
import { Slide, toast, ToastContainer } from "react-toastify";
import { Toaster } from "../../themes/Default/components/Toaster";
import { format } from "date-fns";
import { calendarHolidaysManagement } from "../../hooks/api/CalendarHolidaysManagement";

const AddGroupStudents = () => {
    const { t } = useTranslation("common");
    const formRef = useRef(null);
    const navigate = useNavigate();
    const { groupId } = useParams();
    const [groupName, setGroupName] = useState("");
    const [group, setGroup] = useState([]);
    const [students, setStudents] = useState([]);
    const [attachedStudents, setAttachedStudents] = useState([]);
    const [isStarted, setIsStarted] = useState([]);
    const [hasTests, setHasTests] = useState(false);
    const [hasProgress, setHasProgress] = useState(false);
    const [hasReport, setHasReport] = useState(false);
    const [hasPlan, setHasPlan] = useState(false);
    
    const { 
        useStudentsListMutation,
    } = studentsManagement;

    const { 
        useListGroupParticipantsMutation,
        useAddGroupParticipantsMutation,
        useDeleteGroupParticipantMutation,
        useViewGroupMutation,
        useCanGroupStartMutation,
        useStartGroupMutation,
        useAddGroupDatesMutation,
        useViewProfessorMutation
    } = groupsManagement;

    const [studentsList] = useStudentsListMutation();
    const [listGroupParticipants] = useListGroupParticipantsMutation();
    const [addGroupParticipants] = useAddGroupParticipantsMutation();
    const [deleteGroupParticipant] = useDeleteGroupParticipantMutation();
    const [viewGroup] = useViewGroupMutation();

    const { useCalendarHolidaysListMutation } = calendarHolidaysManagement;
    const [holidayList] = useCalendarHolidaysListMutation();
    const [addGroupDates] = useAddGroupDatesMutation();
    const [viewGroupProfessor] = useViewProfessorMutation();

    const [canGroupStart] = useCanGroupStartMutation();
    const [startGroup, setStartGroup] = useState(true);
    const [groupStart] = useStartGroupMutation();

    const [startDate, setStartDate] = useState([]);
    const [selectedWeekdays, setSelectedWeekdays] = useState([]);
    const [classNumber, setClassNumber] = useState();
    const [classStartTime, setClassStartTime] = useState([]);
    const [classEndTime ,setClassEndTime] = useState([]);
    const [classStartTime2, setClassStartTime2] = useState([]);
    const [selectedWeekdays2, setSelectedWeekdays2] = useState([]);

    const tabs = [
        ...(isStarted ? [
            { title: t('groups.attendance'), onClick: () => gotoAttendanceTab(groupId)  },
            ...(hasPlan ? [
                { title: t('groups.planning'), onClick: () => gotoPlanningTab(groupId)},
            ] : []), 
            ...(hasProgress ? [
                { title: t('groups.progress'), onClick: () => gotoProgressTab(groupId)},
            ] : []), 
            ...(hasTests ? [
                { title: t('groups.progressTest'), onClick: () => gotoProgressTestTab(groupId) }
            ] : []), 
            ...(hasReport ? [
                { title: t('reports.title'),onClick: () => gotoReportTab(groupId)},
            ] : []),
            { title: t('documents'), onClick: () => gotoDocumentsTab(groupId)},
            { title: t('notes'), onClick: () => gotoNotesTab(groupId)},
        ] : []),
        { title: t("settings.title"), link: "/settings/reports", isActive: true },
    ];

    const gotoPlanningTab = (groupId) => {
        navigate("/groups/" + groupId + "/planning");
    }

    const gotoReportTab = (groupId) => {
        navigate("/groups/" + groupId + "/reports");
    }

    const gotoProgressTestTab = (groupId) => {
        navigate("/groups/" + groupId + "/tests");
    }

    const gotoProgressTab = (groupId) => {
        navigate("/groups/" + groupId + "/progress");
    }

    const gotoNotesTab = (groupId) => {
        navigate("/groups/" + groupId + "/notes");
    }

    const gotoDocumentsTab = (groupId) => {
        navigate("/groups/" + groupId + "/documents");
    }

    const gotoAttendanceTab = (groupId) => {
        navigate("/groups/" + groupId + "/attendance");
    }

    const gotoCalendarStep = () => {
        navigate('/groups/' + groupId + '/calendar/add');
    };

    const gotoProfessorStep = () => {
        navigate("/groups/" + groupId + "/professor");
    };

    const gotoDetails = (values) => {
        navigate('/groups/edit/' + groupId);
    };

    const gotoEditStudent = (studentId) => {
        navigate("/students/edit/" + studentId);
    };

    const generateSelectedDates = async (totalClasses) => {
        if (!startDate || totalClasses <= 0) return [];
    
        const result = await holidayList();
        const holidays = result?.data?.records || [];
        const holidayDates = new Set(holidays.map(h => h.date));
    
        const classes = [];
        let currentDate = new Date(startDate);
    
        const weekdayToggle = {};
    
        while (classes.length < totalClasses) {
            const dayIndex = currentDate.getDay() === 0 ? 6 : currentDate.getDay() - 1;
            const isoDate = currentDate.toISOString().split("T")[0];
    
            if (!holidayDates.has(isoDate)) {
    
                const hasFirst = selectedWeekdays.includes(dayIndex);
                const hasSecond = selectedWeekdays2.includes(dayIndex);
    
                if ((hasFirst || hasSecond) && classes.length < totalClasses) {
    
                    if (hasFirst && hasSecond) {
                        const useFirst = weekdayToggle[dayIndex] ?? true;
    
                        const startTime = useFirst ? classStartTime : classStartTime2;
    
                        classes.push({
                            date: isoDate,
                            timeFrom: startTime,
                            timeTo: calculateEndTime(startTime),
                        });
    
                        weekdayToggle[dayIndex] = !useFirst;
                    } 
                    else if (hasFirst) {
                        classes.push({
                            date: isoDate,
                            timeFrom: classStartTime,
                            timeTo: calculateEndTime(classStartTime),
                        });
                    } 
                    else if (hasSecond) {
                        classes.push({
                            date: isoDate,
                            timeFrom: classStartTime2,
                            timeTo: calculateEndTime(classStartTime2),
                        });
                    }
                }
            }
    
            currentDate.setDate(currentDate.getDate() + 1);
        }
    
        return classes;
    }; 

    const calculateEndTime = (startTime) => {
        if (!startTime || !Number(classEndTime)) return "";
    
        const [h, m] = startTime.split(":").map(Number);
        const date = new Date();
        date.setHours(h, m, 0, 0);
    
        const end = new Date(date.getTime() + Number(classEndTime) * 60000);
    
        return `${end.getHours().toString().padStart(2, "0")}:${end
            .getMinutes()
            .toString()
            .padStart(2, "0")}`;
    };

    const onStartGroup = () => {
        toast.warn(
            ({ closeToast }) => (
                <Toaster
                    closeToast={closeToast}
                    description={t("groups.confirmStart")}
                    optionNo={t("no")}
                    optionYes={t("yes")}
                    onClick={() => {
                        closeToast();
                        (async () => {
                            const selectedDates = await generateSelectedDates(classNumber);
                            
                            if (selectedDates.length === 0) {
                                toast.error("Morate odabrati dane i raspon datuma.");
                                return;
                            }
                        
                            const body = { dates: selectedDates };
                        
                            addGroupDates({ body, groupId }).then((result) => {
                                if (result?.error) {
                                    toast.error(result?.error?.data?.error?.responseMessage);
                                } else {
                                    toast.info(result?.data?.info?.responseMessage);
                                    groupStart({ groupId }).then((result) => {
                                        if (result?.error) {
                                            toast.error(result.error.data.error.responseMessage);
                                        } else {
                                            setStartGroup(false);
                                            setIsStarted(true);
                                            toast.info(result?.data?.info?.responseMessage);
                                        }
                                    });
                                }
                            });
                        })();
                    }}
                />
            ),
            {
                autoClose: false,
                progress: false,
                closeButton: false,
            },
        );
    };

    const onRemove = (participantId) => {
        toast.warn(
            ({ closeToast }) => (
                <Toaster
                    closeToast={closeToast}
                    description={t("areYouSure")}
                    optionNo={t("no")}
                    optionYes={t("yes")}
                    onClick={() => {
                        closeToast();
                        deleteGroupParticipant({participantId, groupId}).then((result) => {
                            if (result?.error) {
                                toast.error(result?.error?.data?.error?.responseMessage);
                            } else {
                                toast.info(result?.data?.info?.responseMessage);
                                loadAttachedParticipants();
                            }
                        })
                    }}
                />
            ),
            {
                autoClose: false,
                progress: false,
                closeButton: false,
            },
        );
    };

    const loadAttachedParticipants = () => {
        listGroupParticipants(groupId).then((result) => {
            setAttachedStudents(result?.data?.records);
        });
    }

    const loadGroupName = () => {
        viewGroup(groupId).then((result) => {
            setGroup(result?.data);
            setGroupName(result?.data?.name);
            setIsStarted(result?.data?.hasStarted);
            setHasTests(result?.data?.hasTests);
            setHasReport(result?.data?.hasReport);
            setHasPlan(result?.data?.hasPlan);
            setHasProgress(result?.data?.hasProgress);
            setSelectedWeekdays(Array.isArray(result.data.weekDays) ? result.data.weekDays : []);
            setSelectedWeekdays2(Array.isArray(result.data.weekDays2) ? result.data.weekDays2 : []);
            setClassNumber(result?.data?.classNumber);
            setClassStartTime(result?.data?.classStartTime);
            setClassStartTime2(result?.data?.classStartTime2);
            setClassEndTime(result?.data?.classDuration);
            if (result?.data?.hasStarted === true) {
                setStartGroup(false);
            }else{
                canGroupStart({groupId}).then((result) => {
                    setStartGroup(result?.data?.canStart);
                });
            }
        });
    }

    useEffect(() => {
        studentsList().then((result) => {
            let options = [];
            result?.data?.records.map((student) => {
                options.push(
                    {
                        id: student.id,
                        name: student.firstName + ' ' + student.lastName + ' ' + student.dateOfBirth
                    }
                );
            })
            setStudents(prepareSelect(options));
        });
        loadAttachedParticipants();
        loadGroupName();

        viewGroupProfessor({groupId}).then((result) => {
            if(result?.data){
                setStartDate(result?.data?.firstDate);
            }
        });
     }, []);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to="/groups" />
                <Button title={t("groups.startGroup")} icon="fa-regular fa-play" onClick={onStartGroup} isDisabled={!startGroup}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
            <Title fullWidth={"100%"}>
                {groupName}
                <span className="numOfClasses">
                    Minimum:{" "}
                    <span
                        style={{
                            color:
                                attachedStudents.length < group.minStudents
                                    ? "#FF0000"
                                    : "#27AE60",
                        }}
                    >
                        {group.minStudents}
                    </span>{" "}
                    Maksimum:{" "}
                    <span
                        style={{
                            color:
                                attachedStudents.length > group.maxStudents
                                    ? "#FF0000"
                                    : "#27AE60",
                        }}
                    >
                        {group.maxStudents}
                    </span>
                </span>
            </Title>
                <Breadcrumps>
                    <Link title={t('groups.title')} icon="fa-light fa-users"/>
                    <Link title={t('details')} isActive={true}/>
                </Breadcrumps>
                <br/>
                <br/>
                <br/>
                <Wizard>
                    <Step title={t('groups.basicInfo')} isChecked={true} onClick={gotoDetails}/>
                    <Step title={t('groups.chooseStudents')} isActive={true} />
                    <Step title={t("groups.chooseProfessor")} isChecked={true} onClick={gotoProfessorStep} />
                    <Step title={t('groups.selectDates')} isChecked={true} onClick={isStarted ? gotoCalendarStep : undefined} />
                </Wizard>
                <br/>
                <br/>
                <br/>
                <Formik
                    innerRef={formRef}
                    initialValues={{ 
                        students: "", 
                    }}
                >
                    {({ values, handleChange, setFieldValue, resetForm }) => (
                        <Form>
                            <Row>
                                <Field>
                                    <Select 
                                        label="Odaberi polaznika:"
                                        name="students" 
                                        options={students}  
                                        selectedValue={values.students}
                                        onChange={(event) => {
                                            setFieldValue('students', event.target.value);
                                            const body = {
                                                participants: [event.target.value]
                                            };
                                            addGroupParticipants({body, groupId}).then((result) => {
                                                if (result?.error) {
                                                    toast.error(result?.error?.data?.error?.responseMessage);
                                                    setFieldValue('students', '');
                                                } else {
                                                    toast.info(result?.data?.info?.responseMessage);
                                                    setFieldValue('students', '');
                                                    loadAttachedParticipants();                                
                                                }
                                            });
                                        }}
                                        searchInDropdown={false}
                                    />
                                </Field>
                                <Field></Field>
                            </Row>
                        </Form>
                    )}
                </Formik>
                <br />
                <List>
                    <ListHeader>
                        <ListTitle 
                            title={t('students.title')}
                            subtitle="List of the students who are attached to this group" 
                        />
                    </ListHeader>
                    <ListBody>
                        <TableHead>
                            <TableRow>
                                <TableHeadCell></TableHeadCell>
                                <TableHeadCell><span>{t("groups.no")}</span></TableHeadCell>
                                <TableHeadCell><span>{t("Aktivan/Arhiviran")}</span></TableHeadCell>
                                <TableHeadCell><span>{t('groups.fullName')}</span></TableHeadCell>
                                <TableHeadCell><span>{t('students.dateOfBirth')}</span></TableHeadCell>
                                <TableHeadCell><span>{t('Status')}</span></TableHeadCell>
                                <TableHeadCell></TableHeadCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {attachedStudents?.length > 0 &&
                            attachedStudents?.map((attachedStudent, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableDataCell></TableDataCell>
                                        <TableDataCell>{String(index + 1).padStart(2, "0")}</TableDataCell>
                                        <TableDataCell>
                                            <span style={{ color: attachedStudent.isArchived ? '#ff0000' : '#27ae60' }}>
                                                {attachedStudent.isArchived ? t("Arhiviran") : t("Aktivan")}
                                            </span>
                                        </TableDataCell>
                                        <TableDataCell>
                                            <Button 
                                                title={attachedStudent.firstName + ' ' + attachedStudent.lastName}
                                                onClick={() => gotoEditStudent(attachedStudent.id)}
                                            />
                                        </TableDataCell>
                                        <TableDataCell>{attachedStudent.dateOfBirth + '.'}</TableDataCell>
                                        <TableDataCell>
                                            <span
                                                style={{
                                                    color:
                                                        attachedStudent.status === "Upisan" || attachedStudent.status === "Poslat"
                                                            ? "#27ae60"
                                                            : attachedStudent.status === "Arhiviran"
                                                            ? "#ff0000"
                                                            : attachedStudent.status === "Gratis"
                                                            ? "#FEC33B"
                                                            : "inherit"
                                                }}
                                            >
                                                {attachedStudent.status}
                                            </span>
                                        </TableDataCell>
                                        <TableDataCell>
                                            { !attachedStudent.isArchived ? <Button icon="fa-solid fa-xmark" onClick={() => onRemove(attachedStudent.id)}></Button> : null}
                                        </TableDataCell>
                                    </TableRow>
                                )
                        })}
                        </TableBody>
                    </ListBody>
                </List>
            </Main>
        </DefaultLayout>
    );
};

export default AddGroupStudents;
